import React, { useState } from 'react';
import { useStore } from '../../context/StoreContext';

export default function QuickViewModal() {
  const { quickViewOpen, setQuickViewOpen, quickViewProduct, addToCart, toggleWishlist, wishlist } = useStore();
  const [selectedSize, setSelectedSize] = useState(quickViewProduct?.sizes?.[0] || 'M');
  
  if (!quickViewOpen || !quickViewProduct) return null;

  const formatPrice = (n) => '₹' + n.toLocaleString('en-IN');
  const isWishlisted = wishlist.includes(quickViewProduct.id);

  const handleAddToCart = () => {
    addToCart(quickViewProduct, selectedSize);
    setQuickViewOpen(false);
  };

  return (
    <div className="fixed inset-0 z-[100]">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setQuickViewOpen(false)}></div>
      <div className="absolute inset-x-4 md:inset-x-auto md:left-1/2 md:-translate-x-1/2 top-1/2 -translate-y-1/2 w-full md:w-[900px] bg-white rounded-[28px] shadow-2xl overflow-hidden max-h-[90vh] flex flex-col md:flex-row">
        <button onClick={() => setQuickViewOpen(false)} className="absolute top-4 right-4 w-9 h-9 grid place-items-center rounded-full bg-white/90 backdrop-blur z-10">
          <i className="ri-close-line text-xl"></i>
        </button>
        
        <div className="md:w-[48%] bg-slate-100">
          <img src={quickViewProduct.img} className="w-full h-[360px] md:h-full object-cover" alt={quickViewProduct.name} />
        </div>
        
        <div className="flex-1 p-6 md:p-8 overflow-y-auto">
          <p className="text-xs font-bold tracking-widest uppercase text-indigo-600">{quickViewProduct.brand}</p>
          <h3 className="font-display text-[28px] mt-1">{quickViewProduct.name}</h3>
          <div className="flex items-center gap-2 mt-2">
            <div className="flex text-amber-500"><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-half-fill"></i></div>
            <span className="text-xs text-slate-500">({quickViewProduct.reviews} reviews)</span>
          </div>
          <div className="mt-4 flex items-baseline gap-3">
            <span className="text-2xl font-bold">{formatPrice(quickViewProduct.price)}</span>
            <span className="text-slate-400 line-through">{formatPrice(quickViewProduct.mrp)}</span>
            <span className="px-2 py-0.5 rounded-full bg-rose-50 text-rose-600 text-xs font-bold">{quickViewProduct.off}% OFF</span>
          </div>
          <p className="text-sm text-slate-600 mt-4 leading-relaxed">{quickViewProduct.desc}</p>
          
          <div className="mt-6">
            <p className="text-sm font-semibold mb-2">Select Size</p>
            <div className="flex flex-wrap gap-2">
              {quickViewProduct.sizes.map(size => (
                <button
                  key={size}
                  onClick={() => setSelectedSize(size)}
                  className={`px-3 h-10 rounded-xl border text-sm font-semibold transition ${
                    selectedSize === size ? 'border-slate-900 bg-slate-900 text-white' : 'hover:border-slate-900'
                  }`}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>
          
          <div className="mt-6 flex gap-3">
            <button onClick={handleAddToCart} className="flex-1 h-12 rounded-2xl bg-slate-900 text-white font-semibold">Add to Bag</button>
            <button onClick={() => toggleWishlist(quickViewProduct.id)} className="w-12 h-12 grid place-items-center rounded-2xl border hover:bg-slate-50">
              <i className={`ri-heart-3-${isWishlisted ? 'fill text-rose-600' : 'line'} text-xl`}></i>
            </button>
          </div>
          
          <div className="mt-6 grid grid-cols-3 gap-3 text-center text-xs">
            <div className="p-3 rounded-2xl bg-slate-50"><i className="ri-truck-line text-lg"></i><p className="mt-1 font-semibold">Free Delivery</p></div>
            <div className="p-3 rounded-2xl bg-slate-50"><i className="ri-refresh-line text-lg"></i><p className="mt-1 font-semibold">Easy Returns</p></div>
            <div className="p-3 rounded-2xl bg-slate-50"><i className="ri-shield-check-line text-lg"></i><p className="mt-1 font-semibold">Authentic</p></div>
          </div>
        </div>
      </div>
    </div>
  );
}